<template>
  <div>
    <br />
    <b-row class="row not-print" style="margin-left: 4px">
      <b-col>
        <form @keyup.enter="search()" @submit.prevent>
          <div class="row pt-3">
            <div class="col-4">
              <text-input
                v-model="searchForm.text"
                placeholder="Pesquisar"
                v-debounce:100ms="search"
              />
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-sm btn-primary mr-3"
                @click="showFilters = !showFilters"
              >
                <i class="fas fa-filter" /> Mais Filtros
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="search()"
              >
                <i class="fas fa-search" /> Pesquisar
              </button>
            </div>

            <div class="col text-right mr-4">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="print()"
              >
                <i class="fas fa-print mr-1" /> Imprimir
              </button>
            </div>
          </div>
          <b-collapse v-model="showFilters">
            <b-row  style="margin-right: 10px">
              <b-col cols="2" class="mt-2" align-self="center">
                <date-input
                  v-model="searchForm.due_date_start"
                  alias="Data de vencimento Inicial"
              />
              </b-col>
              <b-col cols="2" class="mt-2" align-self="center">
                <date-input
                  v-model="searchForm.due_date_end"
                  alias="Data de vencimento Final"
              />
              </b-col>
              <b-col  cols="2" class="mt-2" align-self="center">
                <date-input
                  v-model="searchForm.issue_date_start"
                  alias="Data de emissão Inicial"
              /></b-col >
              <b-col cols="2" class="mt-2" align-self="center">
                <date-input
                  v-model="searchForm.issue_date_end"
                  alias="Data de emissão Final"
              /></b-col>
              <b-col cols="2" class="mt-2" align-self="center">
                <date-input
                  v-model="searchForm.archived_at_start"
                  alias="Data de arquivamento Inicial"
              /></b-col>
              <b-col cols="2" class="mt-2" align-self="center">
                <date-input
                  v-model="searchForm.archived_at_end"
                  alias="Data de arquivamento Final"
              /></b-col>
            </b-row>
            <b-row  style="margin-right: 10px">
            <b-col cols="2" class="mt-2" align-self="center">
              <client-search v-model="searchForm.customer_id" />
             </b-col>
             <b-col cols="2" class="mt-2" align-self="center">
              <salesman-search v-model="searchForm.salesman_id" />          
            </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="mt-1 mb-2" align-self="center">
                <b-button @click="clear()" class="x-small" size="sm">
                  <i class="fas fa-times" /> Limpar Filtro
                </b-button>
              </b-col>
              <b-col align-self="center">
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="search()"
                  :value="'o'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Em Aberto</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="search()"
                  :value="'p'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Pagos</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="search()"
                  :value="'a'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Arquivados</small>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-collapse>
        </form>
      </b-col>
    </b-row>

    <div class="row" style="margin: 3px">
      <div class="col">
        <b-card title="Relatório  Contas a Receber">
          <div class="row">
            <div class="col-5">
              <div v-if="searchForm.status == 1">
                Somente clientes com saldo Devedor
              </div>
              <div v-if="searchForm.status == 0">
                Somente clientes sem saldo Devedor
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" v-if="searchForm.due_date_start">
              <span> Consulta realizada apartir de </span>
              {{ searchForm.due_date_start | dateBr }}

              <span v-if="searchForm.due_date_end">
                até {{ searchForm.due_date_end | dateBr }}
              </span>
            </div>
          </div>
          <br />
          <div class="mr-2 row justify-content-between">
            <div class="col">
              <span class="font-weight-bold">Total de Contas em aberto: </span>
              {{ (sum_value - sum_received) | moneyBr }}
            </div>
            <div class="col">
              <span class="font-weight-bold">Total de Contas recebidas: </span>
              {{ sum_payed | moneyBr }}
            </div>
            <div class="col">
              <span class="font-weight-bold">Consulta Realizada :</span>
              {{ date | dateTimeBr }}
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="row" style="margin: 3px">
      <div class="col">
        <div class="card">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th style="text-align: center; width: 20%" scope="col">
                  Nome/Cód.
                </th>
                <th style="text-align: center" cope="col">Emissão</th>
                <th style="text-align: center" cope="col">Doc.</th>
                <th style="text-align: center" scope="col">Vencimento</th>
                <th style="text-align: center" scope="col">Valor</th>
                <th style="text-align: center" scope="col">Juros</th>
                <th style="text-align: center" scope="col">Acréscimo</th>
                <th style="text-align: center" scope="col">Desconto</th>
                <th style="text-align: center" scope="col">Valor Pago</th>
                <th style="text-align: center" scope="col">Pagamento</th>
                <th style="text-align: center" scope="col">Saldo Devedor</th>

              </tr>
            </thead>
            <tbody v-for="(row, index) in bills" :key="index">
              <tr>
                <td colspan="10">
                  {{ row.person.name }}
                  <small>#{{ row.person.person_code }}</small>
                </td>
              </tr>
              <tr v-for="(rowBill, bilIndex) in row.person_bills" :key="bilIndex">
                <td style="text-align: center; width: 20%">
                  <template v-if="rowBill.status == 'a'">
                    <small>Arquivado {{ rowBill.archived_at | dateBr }} </small>
                  </template>
                </td>
                <td style="text-align: center">{{ rowBill.issue_date | dateBr }}</td>
                <td style="text-align: center">{{ rowBill.document }}</td>
                <td style="text-align: center">{{ rowBill.due_date | dateBr }}</td>
                <td style="text-align: end">{{ rowBill.value | decimal }}</td>
                <td style="text-align: end">{{ getInterest(rowBill) | decimal }}</td>
                <td style="text-align: end">{{ rowBill.addition | decimal }}</td>
                <td style="text-align: end">{{ rowBill.discount | decimal }}</td>
                <td style="text-align: end">{{ rowBill.payed_value | decimal }}</td>
                <td style="text-align: center" v-if="rowBill.payed_at">{{ rowBill.payed_at | dateBr }}</td>
                <td style="text-align: center" v-if="rowBill.payed_at == null">A Receber</td>
                <td style="text-align: end">{{ (getInterest(rowBill) + (rowBill.value - rowBill.received_value))| decimal}}</td>
              </tr>
              <tr>
                <th colspan="4">Valores Totais</th>
                <th style="text-align: end">{{ row.value_sum | decimal }}</th>
                <th style="text-align: end">{{ sumInterest(row.person_bills) | decimal }}</th>
                <th style="text-align: end">{{ row.addition_total | decimal }}</th>
                <th style="text-align: end">{{ row.discount_total | decimal }}</th>
                <th style="text-align: end">{{ row.payed_total | decimal }}</th>
                <th></th>
                <th style="text-align: end">{{(sumInterest(row.person_bills) +(row.value_sum - row.received_value_total)) | decimal}}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CollapseOfTheBillReceivebleFilter from "../../components/billReceiveble/filter/CollapseOfTheBillReceivebleFilter";
import BillReceivebleStatsCard from "../../components/billReceiveble/sections/BillReceivebleStatsCard.vue";
import DueDateBadge from "../../components/ui/DueDateBadge.vue";
import ClientSearch from "@/components/ClientSearch";
import SalesmanSearch from "@/components/SalesmanSearch";

export default {
  props: {},
  components: {
    CollapseOfTheBillReceivebleFilter,
    BillReceivebleStatsCard,
    DueDateBadge,
    ClientSearch,
    SalesmanSearch
  },

  data() {
    return {
      showFilters: true,
      searchForm: {
        text: null,
        due_date_start: null,
        due_date_end: null,
        status: ["o"],        
      },
      bills: {},
      sum_payed: {},
      sum_value: {},
      sum_received: {},
    };
  },
  mounted() {
    this.$store.commit("pageHasLoaded");
    this.search();
  },
  computed: {
    date() {
      return moment().format();
    },
    company() {
      return this.$store.state.company;
    },

    interestFactor() {
      if (this.company.bill_interest_calculation_method == "s") {
        return parseFloat(this.company.bill_interest_rate / 100);
      } else {
        return parseFloat(
          Math.pow(this.company.bill_interest_rate / 100 + 1, 1 / 30)
        );
      }
    },
  },
  methods: {
    search(page = 1) {
      this.$store.commit("showLoading");
      axios;
      this.$store
        .dispatch("billreceiveble/getBillReceivebleReport", this.searchForm)
        .then((response) => {
          this.bills = response.data.bills;

          this.sum_payed = response.data.sum_payed.sum_payed_value;
          this.sum_value = response.data.sum_value.value_total;
          this.sum_received = response.data.sum_received.sum_received_total;
          this.$store.commit("hideLoading");
        })

        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    clear() {
      this.searchForm.text = null;
      this.searchForm.due_date_start = null;
      this.searchForm.due_date_end = null;
      this.searchForm.issue_date_start = null
      this.searchForm.issue_date_end = null
      this.searchForm.status = ["o"];
      this.search();
    },

    print() {
      window.print();
    },

    getInterest(bill) {
      if (bill.status == "o") {
        let days = moment().diff(moment(bill.due_date, "YYYY-MM-DD"), "days");

        if (days < 0) {
          return 0;
        }

        if (this.company.bill_interest_calculation_method == "s") {
          return (
            (((bill.value - bill.received_value) * this.interestFactor) / 30) *
            days
          );
        } else {
          return (
            (bill.value - bill.received_value) *
            (Math.pow(this.interestFactor, days) - 1)
          );
        }
      } else {
        return parseFloat(bill.interest);
      }
    },
    sumInterest(person_bills) {
      return person_bills.reduce((sum, row) => sum + this.getInterest(row), 0);
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}

hr.color {
  border: 1px solid black;
}
</style>
